import React from 'react';
import formatHotelRoomPossibilities from '../utilities/formatHotelRoomPossibilities';

export default function CheckoutHotelRoomSelectionList({
  isLoading,
  selectedRooms,
  availableRooms,
  isOtherProposal,
  filters,
  currentIndex,
  currentPossibilityIndex,
  setCurrentPossibilityIndex,
  promoList,
  selectedPromotionSupplements,
  setSelectedPromotionSupplements,
  selectedRoomsFromPromotionSelect,
  renderSelectedRoom,
  renderAvailableRoom,
  renderLoading,
  renderEmpty,
}) {
  const formattedPossibilities = formatHotelRoomPossibilities(availableRooms);

  return (
    <div className="flex-col space-y-5">
      {isLoading && renderLoading && renderLoading()}

      {!isLoading &&
        selectedRooms.length === 0 &&
        (!availableRooms || availableRooms.length === 0) &&
        renderEmpty &&
        renderEmpty()}

      {!isOtherProposal &&
        selectedRooms?.length > 0 &&
        selectedRooms.map((room, selectedRoomIndex) =>
          renderSelectedRoom({
            room,
            selectedRoomIndex,
            filters,
            promoList,
            selectedPromotionSupplements,
            setSelectedPromotionSupplements,
          }),
        )}

      {!isOtherProposal && selectedRooms?.length > 0 && <hr />}

      {formattedPossibilities?.length > 0 &&
        formattedPossibilities.map((possibility, possibilityIndex) => {
          return renderAvailableRoom({
            key: possibilityIndex,
            possibility,
            possibilityIndex,
            currentIndex,
            currentPossibilityIndex,
            setCurrentPossibilityIndex,
            filters,
            promoList,
            selectedRoomsFromPromotionSelect,
            selectedPromotionSupplements,
            setSelectedPromotionSupplements,
            selectedRoomsCount: selectedRooms?.length,
          });
        })}
    </div>
  );
}
